import React from 'react';
import Link from 'next/link';
import { Example } from '@/types/Example';
import CommandParagraph from './CommandParagraph';
import ShortDescription from './ShortDescription';
import { cn } from '@/lib/utils';
import ColourBorder from './ColourBorder';
import CheatActions from './CheatActions';

export interface ExampleSimpleRowProps {
  example: Example;
  className?: string;
  showShortDescription?: boolean;
  editable?: boolean;
}

const ExampleSimpleRow = (props: ExampleSimpleRowProps) => {
  const { example, className, showShortDescription, editable = false } = props;
  const { difficulty, id } = example;

  return (
    <div
      className={cn(
        `not-prose flex h-full w-full items-stretch rounded border bg-gray-50`,
        className,
      )}
      role="region"
      aria-label="card"
    >
      <ColourBorder difficulty={difficulty} />
      <div className="relative flex h-full w-full flex-1 flex-col justify-between">
        <Link
          href={`/examples/${id}`}
          className={cn(`flex-1 transition-colors hover:bg-gray-100`, {
            'pb-6 print:pb-0': editable,
          })}
        >
          <div
            className={cn('relative flex-1 p-2 text-left sm:px-4', {
              'pb-0': showShortDescription,
            })}
          >
            <CommandParagraph
              command={example.example}
              className="text-sm sm:text-base"
            />
            {showShortDescription && (
              <ShortDescription
                className="text-xs sm:text-sm"
                description={example.short_description}
              />
            )}
          </div>
        </Link>
        {editable && (
          <div className="absolute right-0 bottom-0">
            <CheatActions cheat={example} actions="focused" fullCard={false} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExampleSimpleRow;
